/** @format */

import React, { PureComponent } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import CustomTextButtom from '../Buttons/CustomTextButton';
import { DialogContent } from '@material-ui/core';
import I18n from '../Translate/I18n';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import GridItem from '../Grid/GridItem';
import Button from '@material-ui/core/Button';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';
import GridContainer from '../Grid/GridContainer';

interface GeneralDialogProps {
    classes: any;
    open: boolean;
    title: string;
    dispatch?: any;
    fullWidth?: boolean | undefined;
    maxWidth?: false | 'sm' | 'md' | 'xs' | 'lg' | 'xl' | undefined | null;
    height?: any;
    dialogType: 'action' | 'info' | 'none';
    dialogActions?: boolean;
    agreeColor?: any;
    cancelColor?: any;
    disagreeColor?: any;
    agreeCallback?: () => void;
    agreeCallbackTextLabel?: string;
    disagreeCallback?: () => void;
    disagreeCallbackTextLabel?: string;
    dialogContentObject?: object | null;
    agreeButtonDisabled?: boolean;
}

interface GeneralDialogState {
    tmp: any;
}

class GeneralDialog extends PureComponent<GeneralDialogProps, GeneralDialogState> {
    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const {
            maxWidth,
            children,
            open,
            dialogType,
            agreeColor,
            cancelColor,
            disagreeColor,
            fullWidth,
            title,
            agreeCallback,
            disagreeCallback,
            agreeCallbackTextLabel,
            disagreeCallbackTextLabel,
            agreeButtonDisabled,
            dialogActions,
            dialogContentObject,
            height,
        } = this.props;
        let width = maxWidth;
        if (width === undefined || width === null) {
            width = 'md';
        }
        let aC = agreeColor;
        if (aC === null || aC === undefined) {
            aC = 'primary';
        }
        let dC = disagreeColor;
        if (dC === null) {
            dC = 'transparent';
        }
        let dA = dialogActions;
        if (dA === undefined || dA === null) {
            dA = true;
        }

        return (
            <Dialog maxWidth={width} open={open} keepMounted onClose={disagreeCallback} fullWidth={fullWidth} style={height}>
                <DialogTitle>
                    <GridContainer justifyContent={'space-between'}>
                        <h4>
                            <I18n trans={title} />
                        </h4>
                        <Button onClick={disagreeCallback} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridContainer>
                </DialogTitle>
                <DialogContent>
                    {children}
                    {dialogContentObject}
                </DialogContent>
                {dA === true && (
                    <DialogActions>
                        {dialogType === 'action' && (
                            <React.Fragment>
                                <CustomTextButtom
                                    size={'sm'}
                                    callback={agreeCallback}
                                    color={aC}
                                    label={agreeCallbackTextLabel}
                                    disabled={agreeButtonDisabled}
                                />
                            </React.Fragment>
                        )}
                    </DialogActions>
                )}
            </Dialog>
        );
    }
}

// GeneralDialog.propTypes = {
//     title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
//     content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
//     agreeButtonName: PropTypes.string.isRequired,
//     disagreeButtonName: PropTypes.string,
//     open: PropTypes.bool.isRequired,
//     callBackAgree: PropTypes.func.isRequired,
//     callBackDisAgree: PropTypes.func,
//     maxWidth: PropTypes.string,
//     fullWidth: PropTypes.bool,
// };

export default withStyles(oplAppStyle)(GeneralDialog);
